import type { TFunction } from 'i18next'

import { PASSWORD_MIN_LENGTH, PASSWORD_NEEDS_NUMBER_OR_SPECIAL } from '@/generated/passwordRule'

/**
 * The hint under a new-password field, stating the server's rule
 * (agion/Agion#3140, B4). The rule comes from the generated contract
 * src/generated/passwordRule.ts, measured from auth-service
 * credentials.ValidatePassword. The screens only state it; the server judges
 * the password and its refusal sentence is what the screen shows.
 */
export function newPasswordHint(t: TFunction): string {
  const key = PASSWORD_NEEDS_NUMBER_OR_SPECIAL ? 'newPassword.hintWithNumberOrSpecial' : 'newPassword.hint'
  return t(key, { min: PASSWORD_MIN_LENGTH })
}
